import styled from "styled-components";

export const DocumentWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  margin: auto;
`;
